import auth from '../utils/auth';
import { serialize } from '../utils';
import axios from 'axios';

export function removeCart(userId, cartId) {
    return axios.request({
        url: `/customers/${userId}/carts/${cartId}`,
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Session-Key': auth.getSID()
        }
    });
}

export function saveCart(user_id, cart_id, data) {
    return axios.request({
        url: `/customers/${user_id}/carts/${cart_id}`,
        method: 'PUT',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Session-Key': auth.getSID()
        },
        data
    });
}

export function lockCart(user_id, cart_id) {
    return axios.request({
        url: `/customers/${user_id}/carts/${cart_id}`,
        method: 'PUT',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Session-Key': auth.getSID()
        },
        data: {
            isReadOnly: true
        }
    });
}

export function applyPromo(user_id, cart_id, promo_code) {
    return axios.request({
        url: `/customers/${user_id}/carts/${cart_id}/${promo_code}`,
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Session-Key': auth.getSID()
        }
    });
}

export function removePromo(user_id, cart_id, promo_code) {
    return axios.request({
        url: `/customers/${user_id}/carts/${cart_id}`,
        method: 'PUT',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Session-Key': auth.getSID()
        },
        data: {
            promos_applied: []
        }
    });
}

export function getWarranties() {
    let qs = serialize({
        product_type: [
            'warranty-launchpad',
            'warranty-playaway',
            'warranty-view',
            'warranty-bookpacks',
            'warranty-lock'
        ]
    });
    return axios.get(`/products/search?${qs}`);
}

export function createProposal(data) {
    return axios.request({
        url: `/carts/proposal/download`,
        method: 'POST',
        data
    });
}
